import { Spin } from 'antd';
import { ApplicationFormLayout, MainLayout } from 'layouts';
import { OoApplicationViewPage } from 'pages/OoApplicationViewPage';
import { useIsOoCaseNewUiEnabled } from 'providers/PosthogProvider';
import { useApplicationByReferenceNumber } from 'queries';
import { useParams } from 'react-router-dom';
import { LegacyApplicationDetailsPage } from './LegacyApplicationDetailsPage';

export { ApplicationDetailsTab } from './LegacyApplicationDetailsPage';
export type { ApplicationDetailsTabValue } from './LegacyApplicationDetailsPage';

function isMonolithCaseId(id: string | number | undefined): id is string {
  return typeof id === 'string' && id.length > 0;
}

export const ApplicationDetailsPage = () => {
  const params = useParams();
  const referenceNumber = params?.id || '';
  const isOoCaseNewUiEnabled = useIsOoCaseNewUiEnabled();
  const { data: application, isLoading, isError } = useApplicationByReferenceNumber(referenceNumber);

  if (isLoading) {
    return (
      <div className='-mt-16 flex h-full min-h-0 items-center justify-center bg-gray-100'>
        <Spin size='large' />
      </div>
    );
  }

  if (isError || !application) {
    return (
      <div className='-mt-16 flex h-full min-h-0 items-center justify-center bg-gray-100'>
        <Spin size='large' />
      </div>
    );
  }

  // Flag on + monolith case → new OO flow. Legacy-only (or flag off) → old flow.
  if (isOoCaseNewUiEnabled && isMonolithCaseId(application.id)) {
    return (
      <ApplicationFormLayout>
        <OoApplicationViewPage />
      </ApplicationFormLayout>
    );
  }

  return (
    <MainLayout>
      <LegacyApplicationDetailsPage />
    </MainLayout>
  );
};
